import React, { useContext } from "react";
import useTheme from "./useTheme";
import { getStickyItemCSS } from "../utils/sticky";
var StickyContext = /*#__PURE__*/React.createContext();
export var StickyProvider = StickyContext.Provider;

function useSticky(_ref) {
  var id = _ref.id,
      heightMap = _ref.heightMap;
  var theme = useTheme();
  var stickyInfo = useContext(StickyContext);

  if (!stickyInfo) {
    throw new Error("Sticky.Item must be placed inside Sticky.");
  }

  var calculatedOffsetMap = stickyInfo.offsetMap[id];
  var css = getStickyItemCSS({
    heightMap: heightMap,
    offsetMap: calculatedOffsetMap !== null && calculatedOffsetMap !== void 0 ? calculatedOffsetMap : stickyInfo.accumulativeOffsetMap,
    theme: theme
  });

  if (!calculatedOffsetMap) {
    stickyInfo.updateOffsetMap(id, heightMap);
  }

  return {
    css: css
  };
}

export default useSticky;